// extracted by mini-css-extract-plugin
export var tkMyriadProSemiCondensed = "Video--tk-myriad-pro-semi-condensed--4q24s";
export var video = "Video--video--kRzkI";